(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.analytics.directive.analytics-on'

  require('angular')
    .module(MODULE_NAME, [
      require('../analytics')
    ])
    .directive('analyticsOn', analyticsDirective)

  analyticsDirective.$inject = ['analyticsSDK']
  function analyticsDirective (analyticsSDK) {
    return {
      restrict: 'A',
      link: function ($scope, $element, $attrs) {
        var eventType = $attrs.analyticsOn || 'click'
        var trackingData = {}

        angular.forEach($attrs.$attr, function (attr, name) {
          if (isProperty(name)) {
            trackingData[propertyName(name)] = $attrs[name]
            $attrs.$observe(name, function (value) {
              if (name === 'analyticsNexus') {
                try {
                  trackingData[propertyName(name)] = angular.fromJson(value)
                } catch (e) {
                  trackingData[propertyName(name)] = value
                }
              } else {
                trackingData[propertyName(name)] = value
              }
            })
          }
        })

        angular.element($element[0]).bind(eventType, function ($event) {
          var eventName = $attrs.analyticsEvent || inferEventName($element[0])
          trackingData.eventType = $event.type

          if ($attrs.analyticsIf) {
            if (!$scope.$eval($attrs.analyticsIf)) {
              return
            }
          }
          if ($attrs.analyticsProperties) {
            angular.extend(trackingData, $scope.$eval($attrs.analyticsProperties))
          }

          analyticsSDK.setupEventTracking()(eventName, trackingData)
        })
      }
    }
  }

  function isCommand (element) {
    return ['a:', 'button:', 'button:button', 'button:submit', 'input:button', 'input:submit'].indexOf(element.tagName.toLowerCase() + ':' + (element.type || '')) >= 0
  }

  function inferEventName (element) {
    if (isCommand(element)) return element.innerText || element.value
    return element.id || element.name || element.tagName
  }

  function isProperty (name) {
    return name.substr(0, 9) === 'analytics' && ['On', 'Event', 'If', 'Properties', 'EventType'].indexOf(name.substr(9)) === -1
  }

  function propertyName (name) {
    var s = name.slice(9)

    if (typeof s !== 'undefined' && s !== null && s.length > 0) {
      return s.substring(0, 1).toLowerCase() + s.substring(1)
    } else {
      return s
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/analytics/directive/analytics-on.js